<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<section style="{style(block)}" class="bg-gray-200">
  <div class="container">
    <div class="row">
      <div class="col-md-8 ms-auto me-auto text-center">
        <h3>{text(block, 'headline')}</h3>
        <p>{text(block, 'subheadline')}</p>
      </div>
    </div>
    <div class="row mt-5">
      {#each blocklist(block, 'products') as item}
      <div class="col-lg-3 col-md-6 mb-5 d-flex align-items-stretch">
        <div class="card">
          <div class="card-body border-radius-lg position-relative overflow-hidden pb-4 px-5">
            <img class="w-25 mb-3 ms-n2" src="{image(item, 'icon', [50, 50])}" alt="">
            <h5 class="mt-2">{text(item, 'headline')}</h5>
            <p class="mb-3">{@html richtext(item, 'body')}</p>
            <a href="{url(item, 'link')}" class="font-weight-bold text-xs text-uppercase font-weight-bolder text-info icon-move-right">
              {text(item, 'link')}
              <i class="fas fa-arrow-right text-xs ms-1"></i>
            </a>
          </div>
        </div>
      </div>
      {/each}
    </div>
  </div>
</section>
